<template>
  <section id="simulator-pinel" class="simulator">
    <div class="simulator__container">
      <div class="simulator__form">
        <div class="simulator__item required">
          <label for="postcode">Code postal *</label>
          <div class="custom-dropdown">
            <input id="postcode" class="custom-dropdown__input" type="text" placeholder="ex : 34000"
                   v-model="postcode"
                   @focus="focusPostcodeInput()"
                   @keyup.enter="calc">
            <div class="custom-dropdown__menu" v-if="cities.length">
              <ul class="custom-dropdown__list">
                <li class="custom-dropdown__item" :data-id="city.id" :data-zone="city.zone" @click="selectCity(city)" v-for="city in cities">
                  {{ city.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="simulator__item hide">
          <label for="zone">Zone</label>
          <input id="zone" type="text" maxlength="1" size="1" v-model="zone" @keyup.enter="calc">
        </div>
        <div class="simulator__item required">
          <label for="cost">Montant de l'investissement *</label>
          <input id="cost" type="number" placeholder="en euros" v-model="cost" @keyup.enter="calc">
        </div>
        <div class="simulator__item required">
          <label for="area">Surface du logement *</label>
          <input id="area" type="number" placeholder="en m²" v-model="area" @keyup.enter="calc">
        </div>
        <ul v-if="errors.length" class="callout callout--error">
          <li v-for="error in errors">{{ error }}</li>
        </ul>
        <div class="simulator__actions">
          <button class="button" @click="calc">
            <span>Calculer</span>
          </button>
          <button class="link" @click="reset">
            <span class="link__txt">Réinitialiser</span>
          </button>
        </div>
      </div>

      <div id="estimate" class="simulator-result" v-if="isResultVisible">
        <div class="simulator-result__line">
          <span class="simulator-result__label">Éligibilité</span>
          <span class="simulator-result__value">
          <span class="simulator-result__icon" v-if="isEligible"></span>
          {{ eligibility }}
        </span>
        </div>
        <div class="simulator-result__line">
          <span class="simulator-result__label">Loyer maximum</span>
          <span class="simulator-result__value">{{ maxRent }}</span>
        </div>
        <div class="simulator-result__line" v-if="isEligible">
          <span class="simulator-result__label">Réduction d'impôts</span>
          <span class="simulator-result__value">{{ taxReduction6 }}</span>
        </div>
        <div class="simulator-result__line" v-if="isEligible">
          <span class="simulator-result__label">Réduction d'impôts</span>
          <span class="simulator-result__value">{{ taxReduction9 }}</span>
        </div>
        <div class="simulator-result__line" v-if="isEligible">
          <span class="simulator-result__label">Réduction d'impôts</span>
          <span class="simulator-result__value">{{ taxReduction12 }}</span>
        </div>
        <div class="simulator-result__legals">
          <p>Cette simulation est donnée à titre indicatif et n'a pas de valeur contractuelle.</p>
        </div>
      </div>

      <div class="simulator__legals">
        <span>* Ces champs sont obligatoires</span>
      </div>
    </div>
  </section>
</template >

<script>

  export default {
    name: "SimulatorPinel",
    data() {
      return {
        postcode: '',
        zone: '',
        cost: '',
        area: '',
        isEligible: false,
        eligibility: '',
        maxRent: '',
        taxReduction6: '',
        taxReduction9: '',
        taxReduction12: '',
        cities: [],
        isResultVisible: false,
        errors: []
      };
    },
    watch: {
      postcode: function(val, oldVal) {

        if ( val.length != 5 )
          return;

        fetch('https://volund.spiriit.io/api/cities?postalCode=' + val, {
          method: 'GET',
          redirect: 'follow'
        })
        .then(response => response.text())
        .then(result => {
          this.cities = JSON.parse(result);
        })
        .catch(error => console.log('error', error));

      }
    },
    methods: {
      calc: function () {

        this.errors = [];
        this.isResultVisible = false;

        if ( ! this.areFieldsFilled() )
          return;

        fetch('https://volund.spiriit.io/api/pinel?zone=' + this.zone + '&totalCost=' + this.cost + '&propertyArea=' + this.area, {
          method: 'GET',
          redirect: 'follow'
        })
        .then(response => response.text())
        .then(result => {

          this.isResultVisible = true;

          result = JSON.parse(result);
          this.isEligible = result['isEligible'];
          this.eligibility = result['isEligible'] ? 'Éligible' : "Non éligible";
          this.maxRent         = Math.round(result['maxRent']).toLocaleString('fr-FR') + '€';
          this.taxReduction6   = Math.round(result['taxReduction']['6y']).toLocaleString('fr-FR') + '€ (sur 6 ans)';
          this.taxReduction9   = Math.round(result['taxReduction']['9y']).toLocaleString('fr-FR') + '€ (sur 9 ans)';
          this.taxReduction12  = Math.round(result['taxReduction']['12y']).toLocaleString('fr-FR') + '€ (sur 12 ans)';
        })
        .catch(error => console.log('error', error));

      },
      reset: function () {
        this.postcode = '';
        this.zone = '';
        this.cost = '';
        this.area = '';
        this.eligibility = '';
        this.isEligible = false;
        this.maxRent = '';
        this.taxReduction6 = '';
        this.taxReduction9 = '';
        this.taxReduction12 = '';
        this.cities = [];
        this.isResultVisible = false;
        this.errors = [];
      },
      selectCity: function (city) {

        this.zone = city.zone;
        this.cities = [];
        this.postcode = city.postalCode + ' - ' + city.name;

      },
      focusPostcodeInput: function () {

        if ( this.postcode.length > 5 )
          this.postcode = '';

      },
      areFieldsFilled: function () {

        if (this.zone && this.cost && this.area)
          return true;

        if (!this.zone)
          this.errors.push('Veuillez choisir un code postal et une ville.');
        if (!this.cost)
          this.errors.push('Veuillez saisir le montant de votre costissement.');
        if (!this.area)
          this.errors.push('Veuillez saisir la surface du logement.');

        return false;

      }
    }

  };
</script>

